/**
 * Efast Workbench - 产品型号映射管理
 * 从 sales_logic.js 拆分
 */

import { Auth } from "./auth.js";
import { escapeHtml } from "./utils.js";

window._mappingCache = [];
window._mappingsPromise = null;

// ===== 产品型号映射管理 =====

var _mappingCache = [];

async function loadProductMappings() {
    var tbody = document.getElementById('mapping-table-body');
    if (!tbody) return;
    try {
        var data = await Auth.apiFetch('/api/product-mappings');
        _mappingCache = data.mappings || [];
        if (!_mappingCache.length) {
            tbody.innerHTML = '<tr><td colspan="4" style="text-align:center;color:var(--text-muted);">暂无映射，请点击"扫描全店"或"手动添加"</td></tr>';
            return;
        }
        tbody.innerHTML = _mappingCache.map(function(m) {
            var shortUrl = m.aliUrl.length > 50 ? m.aliUrl.substring(0, 47) + '...' : m.aliUrl;
            return '<tr>' +
                '<td>' + m.id + '</td>' +
                '<td><a href="' + escapeHtml(m.aliUrl) + '" target="_blank" title="' + escapeHtml(m.aliUrl) + '">' + escapeHtml(shortUrl) + '</a></td>' +
                '<td><strong>' + escapeHtml(m.erpModel) + '</strong></td>' +
                '<td><button class="btn-action btn-sm" style="background:#ef4444;" onclick="deleteMapping(' + m.id + ')"><i class="fa-solid fa-trash"></i> 删除</button></td>' +
            '</tr>';
        }).join('');
    } catch (e) {
        tbody.innerHTML = '<tr><td colspan="4" style="text-align:center;color:#ef4444;">加载失败: ' + escapeHtml(e.message) + '</td></tr>';
    }
}

async function addMappingManually() {
    var aliUrl = prompt('请输入阿里产品详情页完整URL:');
    if (!aliUrl || !aliUrl.trim()) return;
    aliUrl = aliUrl.trim();
    var erpModel = prompt('请输入对应的ERP型号（如 ZF26）:');
    if (!erpModel || !erpModel.trim()) return;
    erpModel = erpModel.trim().toUpperCase();
    try {
        await Auth.apiFetch('/api/product-mappings', {
            method: 'POST',
            body: JSON.stringify({ aliUrl: aliUrl, erpModel: erpModel })
        });
        loadProductMappings();
    } catch (e) {
        alert('添加失败: ' + e.message);
    }
}

async function deleteMapping(id) {
    if (!confirm('确定要删除此映射吗？')) return;
    try {
        await Auth.apiFetch('/api/product-mappings/' + id, { method: 'DELETE' });
        loadProductMappings();
    } catch (e) {
        alert('删除失败: ' + e.message);
    }
}

function triggerBatchScan() {
    // 通过 postMessage 通知 Chrome 扩展开始批量扫描
    window.postMessage({ source: 'efast_trigger_batch_scan' }, '*');
    var tbody = document.getElementById('mapping-table-body');
    if (tbody) tbody.innerHTML = '<tr><td colspan="4" style="text-align:center;color:#2563eb;"><i class="fa-solid fa-spinner fa-spin"></i> 扫描进行中，请保持在阿里产品列表页...</td></tr>';
}

// 根据URL查找映射的ERP型号（供订单同步使用）
function getErpModelByUrl(aliUrl) {
    if (!aliUrl || !_mappingCache.length) return null;
    // 精确匹配
    var exact = _mappingCache.find(function(m) { return m.aliUrl === aliUrl; });
    if (exact) return exact.erpModel;
    // 模糊匹配：URL包含
    var fuzzy = _mappingCache.find(function(m) { return aliUrl.indexOf(m.aliUrl) !== -1 || m.aliUrl.indexOf(aliUrl) !== -1; });
    return fuzzy ? fuzzy.erpModel : null;
}
// 监听批量扫描结果（接收数据并保存，然后显示结果）
window.addEventListener('message', function(e) {
    if (e.data && e.data.source === 'efast_batch_scan_progress') {
        var tbody = document.getElementById('mapping-table-body');
        if (tbody) tbody.innerHTML = '<tr><td colspan="4" style="text-align:center;color:#2563eb;"><i class="fa-solid fa-spinner fa-spin"></i> 正在扫描第 ' + e.data.page + '/' + e.data.maxPage + ' 页，已收集 ' + e.data.collected + ' 个链接...</td></tr>';
        return;
    }
        if (e.data && e.data.source === 'efast_batch_scan_data' && e.data.items && e.data.items.length) {
        Auth.apiFetch('/api/product-mappings/batch', {
            method: 'POST',
            body: JSON.stringify(e.data.items)
        }).then(function(res) {
            loadProductMappings();
            var msg = '扫描完成！扫描 ' + (e.data.totalScanned || e.data.items.length || 0) + ' 个产品，' +
                '新增 ' + (res.added || 0) + ' 条映射，重复 ' + (res.updated || 0) + ' 条，' +
                '忽略 ' + (res.ignored || 0) + ' 个（型号不在产品中心）';
            if (typeof sT === 'function') showToast('扫描完成', msg.replace('扫描完成！', ''), 'success');
        }).catch(function(err) {
            console.error('批量保存映射失败:', err);
            loadProductMappings();
        });
    }
    // 页面右上角轻量气泡提醒（不打断操作）
function showToast(title, msg, type) {
    var existing = document.getElementById('efast-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'efast-toast';
    toast.style.cssText = 'position:fixed;top:20px;right:20px;z-index:99999;background:#1e293b;color:#f8fafc;border:1px solid #334155;border-radius:8px;padding:12px 18px;min-width:280px;box-shadow:0 10px 40px rgba(0,0,0,0.5);font-family:-apple-system,BlinkMacSystemFont,sans-serif;animation:efastSlideIn 0.3s ease;';
    var icon = type === 'error' ? '❌' : '✅';
    toast.innerHTML = '<div style="display:flex;align-items:flex-start;gap:10px;"><span style="font-size:1.2rem;">' + icon + '</span><div><div style="font-weight:700;margin-bottom:4px;">' + title + '</div><div style="font-size:0.8rem;color:#94a3b8;line-height:1.5;">' + msg + '</div></div></div>';
    document.body.appendChild(toast);
    setTimeout(function() {
        toast.style.opacity = '0';
        toast.style.transition = 'opacity 0.3s';
        setTimeout(function() { if (toast.parentNode) toast.remove(); }, 300);
    }, 4000);
}

// CSS动画注入（只一次）
if (!document.getElementById('efast-toast-style')) {
    var style = document.createElement('style');
    style.id = 'efast-toast-style';
    style.textContent = '@keyframes efastSlideIn{from{transform:translateX(100px);opacity:0}to{transform:translateX(0);opacity:1}}';
    document.head.appendChild(style);
}

    if (e.data && e.data.source === 'efast_batch_scan_result') {
        if (e.data.error) {
            loadProductMappings();
            if (typeof sT === 'function') sT(e.data.error, 'error');
        }
    }
});




// window bridges for template onclick handlers
window.addMappingManually = addMappingManually;

window.deleteMapping = deleteMapping;
export { getErpModelByUrl, loadProductMappings };
